"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormButton = exports.FormSelect = exports.FormInput = void 0;
var react_1 = __importDefault(require("react"));
exports.FormInput = function (_a) {
    var classNames = _a.classNames, id = _a.id, label = _a.label, type = _a.type, value = _a.value, setter = _a.setter;
    return (react_1.default.createElement("div", { className: classNames.formGroup },
        react_1.default.createElement("label", { htmlFor: id }, label),
        react_1.default.createElement("input", { className: classNames.formInput, id: id, type: type || 'text', value: value, onChange: function (e) { return setter(e.target.value); } })));
};
exports.FormSelect = function (_a) {
    var classNames = _a.classNames, id = _a.id, label = _a.label, options = _a.options, setter = _a.setter, props = __rest(_a, ["classNames", "id", "label", "options", "setter"]);
    var handleChange = function (e) {
        setter(options.find(function (v) { return v.key == e.currentTarget.value; }));
    };
    return (react_1.default.createElement("div", { className: classNames.formGroup },
        react_1.default.createElement("label", { htmlFor: id }, label),
        react_1.default.createElement("select", { className: classNames.formInput, id: id, value: props.value.key, onChange: function (e) { return handleChange(e); } }, options.map(function (_a) {
            var text = _a.text, key = _a.key;
            return (react_1.default.createElement("option", { key: key, value: key }, text || key));
        }))));
};
exports.FormButton = function (_a) {
    var className = _a.className, text = _a.text, onClick = _a.onClick;
    var handleClick = function (e) {
        e.preventDefault();
        onClick();
    };
    return (react_1.default.createElement("button", { className: className, onClick: function (e) { return handleClick(e); } }, text));
};
